"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModalTitle = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spacing = require("../../../constants/spacing");
var _typography = require("../../typography");
function omitStyledModalTitleProps(propName) {
  switch (propName) {
    case "type":
      return false;
    default:
      return true;
  }
}
const StyledModalTitle = (0, _styled.default)(_typography.TypeRamp, {
  shouldForwardProp: omitStyledModalTitleProps
})`
    display: flex;
    align-items: center;
    margin: 0;

    ${props => props.type === "simple" ? `
      padding: ${_spacing.sizes.xLarge}px ${_spacing.sizes.xSmall}px 0px ${_spacing.sizes.xLarge}px;
      ` : `
      padding: ${_spacing.sizes.xLarge}px ${_spacing.sizes.xSmall}px ${_spacing.sizes.large}px ${_spacing.sizes.xLarge}px;
      `}

    flex: 1 1 auto;
    // To align the icon and text
    align-items: flex-start;
    min-width: 0; // to support eliding single-line headers
`;
exports.StyledModalTitle = StyledModalTitle;
//# sourceMappingURL=Title.js.map